class VariantRadiosColor extends VariantRadios {
  constructor() {
    super();
    this.colors = {
      red: "hsl(354, 74%, 56%)",
      yellow: "hsl(45, 100%, 51%)",
      mint: "hsl(120, 54%, 65%)",
      green: "hsl(173, 98%, 25%)",
      blue: "hsl(206, 81%, 62%)",
      purple: "hsl(250, 100%, 69%)",
      white: "hsl(0, 0%, 20%)",
      black: "hsl(0, 0%, 20%)",
      pumpkin: "#F37D27",
      latte: "#BFA58D",
      glacier: "#6FA0EF",
      cranberry: "#CF2029",
      iris: "#8F44DC",
      blossom: "#F291B5",
      mango: "#FFAD4A",
      lagoon: "#72D4BD",
      maroon:"#794652",
      slate:"#CBCDCD"
    };
    this.basicColors = [
      "red",
      "yellow",
      "mint",
      "green",
      "blue",
      "purple",
      "white",
      "black",
    ]

    this.backVariantMap = {
      44260402069679: "#000000",
      44260402397359: "#ffffff",
      44260402430127: "hsl(250, 100%, 69%)",
      44260402233519: "hsl(206, 81%, 62%)",
      44260402266287: "hsl(173, 98%, 25%)",
      44260402299055: "hsl(120, 54%, 65%)",
      44260402331823: "hsl(45, 100%, 51%)",
      44260402364591: "hsl(354, 74%, 56%)",
    }

    this.updateOptions();
    this.updateMasterId();
    this.updateQuantityAnimation();
    this.updateButtonAnimation();
    this.updateGiftcardAmount();

    if (!this.currentVariant.name.includes("Gift Card")) {
    this.updateTitle();
    this.updateRestock();
    this.updateColor();
    this.updateIcons();
    this.showSoldOutBanner();
    }

    if (this.productIsBasic()) {
      this.toggleAddButton(
        !this.singleVariantInStock(true),
        window.variantStrings.soldOut
      );
    } else if (this.productIsPreorder()) {
      this.toggleAddButton(
        !this.singleVariantInStock(true),
        window.variantStrings.soldOut,
        false,
        true
      );
    } else {
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateQuantityAnimation();
    this.updateButtonAnimation();
    this.updateGiftcardAmount();

    if (!this.currentVariant.name.includes("Gift Card")) {
      this.updateTitle();
      this.updateRestock();
      this.updateColor();
      this.updateIcons();
      this.getChipVersion();
      this.getChip();
      this.showSoldOutBanner();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVersion();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      if(this.currentVariant.name.includes("dot.metal - custom")){
        this.updateVariantVideo()
        this.updateFrontColor()
      }
    }
  }

  updateFrontColor(){
    const frontCardContainer = document.querySelector(".front-card")
    const frontCardText = document.querySelector(".front-card p")

    if(colorBox && matchColorToggle && matchColorToggle.checked) {
        colorBox.style.backgroundColor = this.backVariantMap[this.currentVariant.id];
        if(frontCardContainer){
            frontCardContainer.style.background = this.backVariantMap[this.currentVariant.id];
          }
        if(frontCardText){
          if(this.currentVariant.id === 44260402397359){
          frontCardText.style.color = "#6c6c6c"
        } else {
          frontCardText.style.color = "#fff"
        }
      }
      }

    if(colorBoxAlt && matchColorToggle && matchColorToggle.checked){
        colorBoxAlt.style.backgroundColor = this.backVariantMap[this.currentVariant.id];
        if(frontCardContainer){
            frontCardContainer.style.background = this.backVariantMap[this.currentVariant.id];
          }
          if(frontCardText){
            if(this.currentVariant.id === 44260402397359){
            frontCardText.style.color = "#6c6c6c"
          } else {
            frontCardText.style.color = "#fff"
          }
        }
      }

      
    if(currentBackVariantId) 
      {currentBackVariantId = this.currentVariant.id}
  }

  updateVariantVideo(){
   document.querySelectorAll(".custom-metal-video").forEach((el) => {
    el.style.display = "none";
   })
   document.getElementById(`${this.currentVariant.id}`).style.display = "block";
  }

  // Show sold out banner for dot.band
  showSoldOutBanner() {
    const banner = document.querySelector(".sold-out-banner");
    const leftTiles = document.querySelector(".tiles-column-left");

    if (this.currentVariant.isRestocking) {
      if(banner && leftTiles){
        banner.classList.add("active");
        leftTiles.classList.add("is-restocking");
        if (banner.classList.contains("sold-out-bundle")) {
          leftTiles.classList.add("is-restocking-bundle");
        }
      }
    } else {
      if(banner && leftTiles){
        banner.classList.remove("active");
        leftTiles.classList.remove("is-restocking");
        leftTiles.classList.remove("is-restocking-bundle");
      }
    }
  }

  getChipVersion() {
    const inputs = this.querySelectorAll("input[name='Version']");
    const chipElement = document.querySelector(".variant-chip");

    if (!inputs.length) return;

    inputs.forEach((input) => {
      if (input.checked) {
        const chiptype = input.dataset.chiptype;
        if (chiptype.toLowerCase() === "new") {
          // chipElement.innerHTML = `<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          // <path d="M6.79688 0.921875L7.875 2H9.375C9.6875 2.01562 9.95312 2.125 10.1719 2.32812C10.375 2.54688 10.4844 2.8125 10.5 3.125V4.64844L11.5781 5.70312C11.7969 5.9375 11.9062 6.20312 11.9062 6.5C11.9062 6.79688 11.7969 7.0625 11.5781 7.29688L10.5 8.375V9.875C10.4844 10.1875 10.375 10.4531 10.1719 10.6719C9.95312 10.875 9.6875 10.9844 9.375 11H7.875L6.79688 12.0781C6.5625 12.2969 6.29688 12.4062 6 12.4062C5.70312 12.4062 5.4375 12.2969 5.20312 12.0781L4.14844 11H2.625C2.3125 10.9844 2.04688 10.875 1.82812 10.6719C1.625 10.4531 1.51562 10.1875 1.5 9.875V8.375L0.421875 7.29688C0.203125 7.0625 0.09375 6.79688 0.09375 6.5C0.09375 6.20312 0.203125 5.9375 0.421875 5.70312L1.5 4.64844V3.125C1.51562 2.8125 1.625 2.54688 1.82812 2.32812C2.04688 2.125 2.3125 2.01562 2.625 2H4.14844L5.20312 0.921875C5.4375 0.703125 5.70312 0.59375 6 0.59375C6.29688 0.59375 6.5625 0.703125 6.79688 0.921875Z" fill="#4FA8ED"/>
          // </svg><span>New</span>
          // `;
          // chipElement.className = "variant-chip variant-chip--new";
        } else if (chiptype.toLowerCase() === "none") {
          chipElement.innerHTML = "";
          chipElement.className = "variant-chip";
        }
      }
    });
  }

  getChip() {
    const inputs = this.querySelectorAll("input[name='Color']");
    const chipElement = document.querySelector(".variant-chip");
    inputs.forEach((input) => {
      if (input.checked) {
        const chiptype = input.dataset.chiptype;
        // console.log(chiptype)
        if (chiptype.toLowerCase() === "limited edition") {
          chipElement.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 2.83594C6.15625 2.83594 6.26562 2.90625 6.32812 3.04688L7.07812 4.52344L8.71875 4.75781C8.85938 4.78906 8.95312 4.875 9 5.01562C9.04688 5.17188 9.01562 5.30469 8.90625 5.41406L7.73438 6.53906L8.01562 8.20312C8.03125 8.34375 7.97656 8.46094 7.85156 8.55469C7.72656 8.64844 7.60156 8.65625 7.47656 8.57812L6 7.82812L4.54688 8.57812C4.40625 8.65625 4.27344 8.64844 4.14844 8.55469C4.02344 8.46094 3.96875 8.34375 3.98438 8.20312L4.26562 6.53906L3.09375 5.41406C2.98438 5.30469 2.95312 5.17188 3 5.01562C3.04688 4.875 3.14844 4.78906 3.30469 4.75781L4.92188 4.52344L5.67188 3.04688C5.73438 2.90625 5.84375 2.83594 6 2.83594ZM12 6C11.9844 7.125 11.7109 8.13281 11.1797 9.02344C10.6484 9.92969 9.92969 10.6484 9.02344 11.1797C8.13281 11.7109 7.125 11.9844 6 12C4.875 11.9844 3.86719 11.7109 2.97656 11.1797C2.07031 10.6484 1.35156 9.92969 0.820312 9.02344C0.289062 8.13281 0.015625 7.125 0 6C0.015625 4.875 0.289062 3.86719 0.820312 2.97656C1.35156 2.07031 2.07031 1.35156 2.97656 0.820312C3.86719 0.289062 4.875 0.015625 6 0C7.125 0.015625 8.13281 0.289062 9.02344 0.820312C9.92969 1.35156 10.6484 2.07031 11.1797 2.97656C11.7109 3.86719 11.9844 4.875 12 6ZM6 1.125C4.625 1.15625 3.47656 1.63281 2.55469 2.55469C1.63281 3.47656 1.15625 4.625 1.125 6C1.15625 7.375 1.63281 8.52344 2.55469 9.44531C3.47656 10.3672 4.625 10.8438 6 10.875C7.375 10.8438 8.52344 10.3672 9.44531 9.44531C10.3672 8.52344 10.8438 7.375 10.875 6C10.8438 4.625 10.3672 3.47656 9.44531 2.55469C8.52344 1.63281 7.375 1.15625 6 1.125Z" />
          </svg>
          <span>Limited Edition</span>
          `;
          chipElement.className = `variant-chip variant-chip--${this.currentVariant.option1.toLowerCase()}`;
        }
        if (chiptype.toLowerCase() === "most popular") {
          chipElement.innerHTML = `<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.61775 5.43064C8.36956 4.84459 8.00877 4.31859 7.55795 3.88554L7.18593 3.52743C7.1733 3.5156 7.1581 3.50721 7.14165 3.50299C7.12521 3.49877 7.10803 3.49884 7.09162 3.50321C7.07521 3.50758 7.06008 3.51611 7.04754 3.52805C7.03501 3.53999 7.02546 3.55497 7.01974 3.57169L6.85354 4.07197C6.74999 4.38582 6.55951 4.70637 6.28977 5.02156C6.27187 5.04168 6.25141 5.04705 6.23735 5.04839C6.22329 5.04973 6.20156 5.04705 6.18238 5.02827C6.16448 5.01217 6.15553 4.98803 6.15681 4.96389C6.20411 4.15647 5.974 3.24577 5.47031 2.2546C5.05355 1.43108 4.47443 0.788629 3.75085 0.340657L3.22287 0.0147377C3.15383 -0.0281818 3.06562 0.0281499 3.06946 0.112648L3.09758 0.75644C3.11676 1.19636 3.06818 1.58532 2.95312 1.90856C2.8125 2.30422 2.61051 2.67172 2.35227 3.00166C2.17256 3.23097 1.96886 3.43837 1.74503 3.61997C1.20593 4.05476 0.767573 4.61186 0.462784 5.24957C0.158745 5.89285 0.000370944 6.60108 0 7.3191C0 7.95216 0.118892 8.5651 0.354119 9.14317C0.581249 9.69974 0.909023 10.2049 1.31932 10.6306C1.73352 11.0598 2.2142 11.3978 2.74986 11.6325C3.30468 11.8766 3.89275 12 4.5 12C5.10724 12 5.69531 11.8766 6.25014 11.6338C6.78447 11.4005 7.27036 11.0602 7.68067 10.6319C8.09488 10.2027 8.41959 9.70113 8.64587 9.14451C8.88074 8.56802 9.00123 7.94738 8.99999 7.32044C8.99999 6.66591 8.87215 6.03017 8.61775 5.43064Z" fill="#FF6A3A"/>
          </svg>
          <span>Most Popular</span>
          `;
          chipElement.className = `variant-chip variant-chip--popular`;
        }
        if (chiptype.toLowerCase() === "fan favorite") {
          chipElement.innerHTML = `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.125 6.53125C0.390625 5.84375 0.015625 4.99219 0 3.97656V3.83594C0.015625 2.99219 0.28125 2.27344 0.796875 1.67969C1.3125 1.07031 1.97656 0.6875 2.78906 0.53125C3.33594 0.453125 3.86719 0.492188 4.38281 0.648438C4.88281 0.804688 5.32812 1.07812 5.71875 1.46875L6 1.75L6.28125 1.46875C6.67188 1.07812 7.11719 0.804688 7.61719 0.648438C8.13281 0.492188 8.66406 0.453125 9.21094 0.53125C10.0234 0.6875 10.6875 1.07031 11.2031 1.67969C11.7188 2.27344 11.9844 2.99219 12 3.83594V3.97656C11.9844 4.99219 11.6094 5.84375 10.875 6.53125L6.65625 10.4922C6.46875 10.6641 6.25 10.75 6 10.75C5.75 10.75 5.53125 10.6641 5.34375 10.4922L1.125 6.53125Z"/>
          </svg>
          <span>Fan Favorite</span>
          `;
          chipElement.className = `variant-chip variant-chip--${this.currentVariant.option1.toLowerCase()}`;
        }
        if (chiptype.toLowerCase() === "low stock: order quickly") {
          chipElement.innerHTML = `<svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.25 6.75H11.1953L7.75 3.30469L5.28906 5.78906C5.13281 5.92969 4.95312 6 4.75 6C4.54688 6 4.36719 5.92969 4.21094 5.78906L0.460938 2.03906C0.320312 1.88281 0.25 1.70312 0.25 1.5C0.25 1.29688 0.320312 1.11719 0.460938 0.960938C0.617188 0.820312 0.796875 0.75 1 0.75C1.20312 0.75 1.38281 0.820312 1.53906 0.960938L4.75 4.19531L7.21094 1.71094C7.36719 1.57031 7.54688 1.5 7.75 1.5C7.95312 1.5 8.13281 1.57031 8.28906 1.71094L12.25 5.69531V3.75C12.25 3.53125 12.3203 3.35156 12.4609 3.21094C12.6016 3.07031 12.7812 3 13 3C13.2188 3 13.3984 3.07031 13.5391 3.21094C13.6797 3.35156 13.75 3.53125 13.75 3.75V7.5C13.75 7.71875 13.6797 7.89844 13.5391 8.03906C13.3984 8.17969 13.2188 8.25 13 8.25H9.25C9.03125 8.25 8.85156 8.17969 8.71094 8.03906C8.57031 7.89844 8.5 7.71875 8.5 7.5C8.5 7.28125 8.57031 7.10156 8.71094 6.96094C8.85156 6.82031 9.03125 6.75 9.25 6.75Z"/>
          </svg>
          <span>Low Stock: Order Quickly</span>
          `;
          chipElement.className = `variant-chip variant-chip--${this.currentVariant.option1.toLowerCase()}`;
        }
        if (chiptype.toLowerCase() === "none" || !chiptype) {
          chipElement.innerHTML = "";
          chipElement.className = "variant-chip";
        }
        // if (chiptype.toLowerCase() === "new") {
        //   chipElement.innerHTML = `<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        //   <path d="M6.79688 0.921875L7.875 2H9.375C9.6875 2.01562 9.95312 2.125 10.1719 2.32812C10.375 2.54688 10.4844 2.8125 10.5 3.125V4.64844L11.5781 5.70312C11.7969 5.9375 11.9062 6.20312 11.9062 6.5C11.9062 6.79688 11.7969 7.0625 11.5781 7.29688L10.5 8.375V9.875C10.4844 10.1875 10.375 10.4531 10.1719 10.6719C9.95312 10.875 9.6875 10.9844 9.375 11H7.875L6.79688 12.0781C6.5625 12.2969 6.29688 12.4062 6 12.4062C5.70312 12.4062 5.4375 12.2969 5.20312 12.0781L4.14844 11H2.625C2.3125 10.9844 2.04688 10.875 1.82812 10.6719C1.625 10.4531 1.51562 10.1875 1.5 9.875V8.375L0.421875 7.29688C0.203125 7.0625 0.09375 6.79688 0.09375 6.5C0.09375 6.20312 0.203125 5.9375 0.421875 5.70312L1.5 4.64844V3.125C1.51562 2.8125 1.625 2.54688 1.82812 2.32812C2.04688 2.125 2.3125 2.01562 2.625 2H4.14844L5.20312 0.921875C5.4375 0.703125 5.70312 0.59375 6 0.59375C6.29688 0.59375 6.5625 0.703125 6.79688 0.921875Z" fill="#4FA8ED"/>
        //   </svg><span>New</span>
        //   `;
        //   chipElement.className = "variant-chip variant-chip--new";
        // }

        const comingSoonBtn = document.querySelector(".coming-soon-button");
        const atcButton = document.querySelector(".product-form");
        if (chiptype.toLowerCase() === "coming soon") {
          atcButton.classList.add("display-none");
          comingSoonBtn.classList.remove("display-none");
          chipElement.innerHTML = `<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.79688 0.921875L7.875 2H9.375C9.6875 2.01562 9.95312 2.125 10.1719 2.32812C10.375 2.54688 10.4844 2.8125 10.5 3.125V4.64844L11.5781 5.70312C11.7969 5.9375 11.9062 6.20312 11.9062 6.5C11.9062 6.79688 11.7969 7.0625 11.5781 7.29688L10.5 8.375V9.875C10.4844 10.1875 10.375 10.4531 10.1719 10.6719C9.95312 10.875 9.6875 10.9844 9.375 11H7.875L6.79688 12.0781C6.5625 12.2969 6.29688 12.4062 6 12.4062C5.70312 12.4062 5.4375 12.2969 5.20312 12.0781L4.14844 11H2.625C2.3125 10.9844 2.04688 10.875 1.82812 10.6719C1.625 10.4531 1.51562 10.1875 1.5 9.875V8.375L0.421875 7.29688C0.203125 7.0625 0.09375 6.79688 0.09375 6.5C0.09375 6.20312 0.203125 5.9375 0.421875 5.70312L1.5 4.64844V3.125C1.51562 2.8125 1.625 2.54688 1.82812 2.32812C2.04688 2.125 2.3125 2.01562 2.625 2H4.14844L5.20312 0.921875C5.4375 0.703125 5.70312 0.59375 6 0.59375C6.29688 0.59375 6.5625 0.703125 6.79688 0.921875Z" fill="#4FA8ED"/>
          </svg><span>Coming Soon</span>
          `;
          chipElement.className = "variant-chip variant-chip--new";
        } else {
          atcButton.classList.remove("display-none");
          comingSoonBtn.classList.add("display-none");
        }
      }
    });
  }

  updateQuantityAnimation() {
    const inputs = this.querySelectorAll("input[name='Quantity']");
    const options = this.querySelectorAll(
      "input[name='Quantity'] + .quantity-option"
    );

    if (options.length > 0 && (this.singleVariantInStock() || this.currentVariant.isRestocking)) {
      inputs.forEach((input) => {
        input.removeAttribute("disabled");
      });

      options.forEach((option) => {
        option.removeAttribute("style");
        option.classList.remove("quantity-option--animate");
      });

      if (inputs[0].checked) {
        options[1].classList.add("quantity-option--animate");
      } else if (inputs[1].checked) {
        options[2].classList.add("quantity-option--animate");
      }

      const optionSingle = document.querySelector("#option-single");
      optionSingle?.setAttribute("data-default-select", "false");
    } else {
      // If a new color is selected and the product is out of stock, set the quantity back to 1
      const optionSingle = document.querySelector("#option-single");
      const defaultSelect = optionSingle?.dataset.defaultSelect === "true";
      if (optionSingle && !defaultSelect) {
        optionSingle.click();
        optionSingle.dataset.defaultSelect = "true";
      }
    }
  }
  updateButtonAnimation() {
    const btn = document.querySelector(".product-add-btn");
    btn.style.pointerEvents = "";
    btn.classList.remove("sold-out");
    if (
      (this.productIsBasic() && this.singleVariantInStock()) ||
      (!this.productIsBasic() && this.currentVariant.available) ||
      this.currentVariant.isRestocking
    ) {
      btn.classList.add("product-add-btn--animate-idle");
    } else {
      btn.style.pointerEvents = "none";
      btn.classList.add("sold-out");
    }
  }
  updateIcons() {
    const icons = this.querySelectorAll(".quantity-option__icon svg");
    const options = this.querySelectorAll(".quantity-option__icon");
    icons.forEach((icon) => {
      icon.setAttribute("class", "");
      icon.classList.add(
        `variant-${this.currentVariant.option1.toLowerCase()}`
      );
    });
    options.forEach((option) => option.removeAttribute("style"));
  }
  updateTitle() {
    const titles = document.querySelectorAll(".product-name__variant");
    for (const title of titles) {
      if (title) title.textContent = this.currentVariant.option1.toLowerCase();
      if (this.currentVariant.options.length > 2 && this.currentVariant.name.includes("duos")) {
        const colorTitles = document.querySelectorAll(".color-name-duo");
        colorTitles.forEach((titleEl, idx) => {
          if (titleEl)
            titleEl.textContent =
              idx === 0
                ? this.currentVariant.option1.toLowerCase()
                : this.currentVariant.option2.toLowerCase();
        });
      }
    }
  }
  updateRestock() {
    const time = document.querySelector(".product__restock-time");

    if (time) time.textContent = this.currentVariant.restockTime;
  }

  updateGiftcardAmount() {
    if (this.currentVariant.name.includes("Gift Card")) {
      const amountPicker = document.querySelector(".giftcard-amount-picker");
      const amountRadios = amountPicker.querySelectorAll("input");
      const goodForCards = document.querySelectorAll(".giftcard-good-for-card");
      amountRadios.forEach((radio) => {
        if (radio.checked) {
          radio.nextElementSibling.classList.add("amount-selected");
          goodForCards.forEach((card) => card.classList.add(`good-for-card--${radio.value.replace("$", "")}`));
        } else {
          radio.nextElementSibling.classList.remove("amount-selected");
          goodForCards.forEach((card) => card.classList.remove(`good-for-card--${radio.value.replace("$", "")}`));
        }
      });
    }
  }

  updateColor() {
   
    const btn = document.querySelector(".product-add-btn");
    const gradientOverlay = document.querySelector(
      ".product-add-btn__gradient-overlay"
    );
    const quantityOptions = this.querySelectorAll(".quantity-option");
    const optionLabels = this.querySelectorAll(".quantity-option__label");
    const priceChip = document.querySelector(".product-price-chip");
    const popupButtonPlus = document.querySelector(".product-add-popup-plus");
    const colorDot = document.querySelector(".color-dot");
    const colorDotDuo = document.querySelectorAll(".color-dot-duo");
    let product = document.querySelector(".product");
    if (!product) product = document.querySelector(".custom-product-main"); // custom metal card
    const colorRowGrid = product.querySelector(".color-row-grid");
    const colorRadios = colorRowGrid.querySelectorAll("input");
    const backCardContainer = document.querySelector(".back-card")

    if(backCardContainer){
      backCardContainer.style.background = this.backVariantMap[this.currentVariant.id]
      const paths = backCardContainer.querySelectorAll('svg path');
      if(this.currentVariant.id === 44260402397359){
        paths.forEach((path) => {
          path.setAttribute('fill', "#6c6c6c")
        })
      } else {
        paths.forEach((path) => {
          path.setAttribute('fill', this.backVariantMap[this.currentVariant.id])
        })
      }
    }

    colorRadios.forEach((radio) => {
      if (radio.checked) {
        radio.nextElementSibling.classList.add(
          `color-circle-selected-${this.currentVariant.option1.toLowerCase()}`
        );
        radio.nextElementSibling.classList.add("color-circle-selected");
      } else {
        radio.nextElementSibling.classList.forEach((className) => {
          if (className.includes("color-circle-selected-")) {
            radio.nextElementSibling.classList.remove(className);
            radio.nextElementSibling.classList.remove("color-circle-selected");
          }
        });
      }
    });

    if(popupButtonPlus){
      popupButtonPlus.classList.forEach((className) => {
        if (className.includes("product-add-popup-plus--")) {
          popupButtonPlus.classList.remove(className);
        }
      });
      popupButtonPlus.classList.add(
        `product-add-popup-plus--${this.currentVariant.option1.toLowerCase()}`
      );
    }

    if (
      (this.currentVariant && this.currentVariant.options.length) <= 2 ||
      this.currentVariant.name.includes("dot.thin") || this.currentVariant.name.includes("bundle")
      || this.currentVariant.name.includes("dot.metal") || this.currentVariant.name.includes("dot.band")
    ) {
      colorDot.className = `color-dot color-dot--${this.currentVariant.option1.toLowerCase()} ${this.currentVariant.name.includes("dot.bundle") ? "color-dot--bundle" : ""}`;

      colorRadios.forEach((radio) => {
        const style = window.getComputedStyle(radio.nextElementSibling);
        if (radio.checked) {
          radio.nextElementSibling.classList.add(
            `color-circle-selected-${this.currentVariant.option1.toLowerCase()}`
          );
          radio.nextElementSibling.classList.add("color-circle-selected");
        } else {
          radio.nextElementSibling.classList.forEach((className) => {
            if (className.includes("color-circle-selected-")) {
              radio.nextElementSibling.classList.remove(className);
              radio.nextElementSibling.classList.remove("color-circle-selected");
            }
          });
        }
      });

      for (const option of quantityOptions) {
        option.className = "quantity-option";
        option.classList.add(
          `quantity-option--${this.currentVariant.option1.toLowerCase()}`
        );
      }
      for (const label of optionLabels) {
        label.className = "quantity-option__label";
        label.classList.add(
          `quantity-option__label--${this.currentVariant.option1.toLowerCase()}`
        );
      }

      btn.className = "product-add-btn";
      if (
        (this.productIsBasic() && this.singleVariantInStock()) ||
        (!this.productIsBasic() && this.currentVariant.available)
      ) {
        btn.classList.add(
          `product-add-btn--${this.currentVariant.option1.toLowerCase()}`
        );
        if (this.currentVariant.name.includes("dot.bundle")) {
          btn.classList.add("product-add-btn--bundle");
        }
      }
    } else if (this.currentVariant.options.length > 2) {
      colorDotDuo.forEach((colorEl, idx) => {
        colorEl.className = `color-dot color-dot-duo color-dot--${
          idx === 0
            ? this.currentVariant.option1.toLowerCase()
            : this.currentVariant.option2.toLowerCase()
        }`;
      });
      const option1Radios = document.querySelectorAll(".radio-first-color");
      const option2Radios = document.querySelectorAll(".radio-second-color");
      option1Radios.forEach((radio) => {
        const style = window.getComputedStyle(radio.nextElementSibling);
        if (radio.checked) {
          radio.nextElementSibling.classList.add(
            `color-circle-selected-${this.currentVariant.option1.toLowerCase()}`
          );
          radio.nextElementSibling.classList.add("color-circle-selected");
        } else {
          radio.nextElementSibling.classList.forEach((className) => {
            if (className.includes("color-circle-selected-")) {
              radio.nextElementSibling.classList.remove(className);
              radio.nextElementSibling.classList.remove("color-circle-selected");
            }
          });
        }
      });
      option2Radios.forEach((radio) => {
        const style = window.getComputedStyle(radio.nextElementSibling);
        if (radio.checked) {
          radio.nextElementSibling.classList.add(
            `color-circle-selected-${this.currentVariant.option2.toLowerCase()}`
          );
          radio.nextElementSibling.classList.add("color-circle-selected");
        } else {
          radio.nextElementSibling.classList.forEach((className) => {
            if (className.includes("color-circle-selected-")) {
              radio.nextElementSibling.classList.remove(className);
              radio.nextElementSibling.classList.remove("color-circle-selected");
            }
          });
        }
      });

      if (this.currentVariant.available) {
        btn.style = `background: linear-gradient(315deg, ${
          this.colors[this.currentVariant.option2.toLowerCase()]
        } 30%, ${this.colors[this.currentVariant.option1.toLowerCase()]} 70%);`;
        gradientOverlay.style.opacity = "0";
        gradientOverlay.ontransitionend = (e) => {
          gradientOverlay.style.background = `linear-gradient(315deg, ${
            this.colors[this.currentVariant.option2.toLowerCase()]
          } 30%, ${
            this.colors[this.currentVariant.option1.toLowerCase()]
          } 70%)`;
          gradientOverlay.style.opacity = "1";
        };
      } else {
        btn.style = "";
        gradientOverlay.style = "";
      }
    } else {
      btn.style = "";
      gradientOverlay.style = "";
    }
  }
}

customElements.define("variant-radios-color", VariantRadiosColor);
